//Imports
import { BACKSTAGE_COLLECTION } from "../../AppConstants/CollectionConstants";
import { firestore } from "../../firebase/firebase";

// Firebase

const getShowsImages = async (rowName) => {
  try {
    let docRef = firestore.collection(BACKSTAGE_COLLECTION).doc(rowName);

    const query = await docRef.get();

    if (query.empty) {
      return [];
    }

    let _data = query.data();

    return _data;
  } catch (error) {
    console.error("Error :: ", error);
    throw error;
  }
};

const get = {
  getShowsImages,
};

export default get;
